import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { routes } from "./app.routes";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { GetInterceptor } from "./core/interceptors/get-interceptor.service";
import { SetInterceptor } from "./core/interceptors/set-interceptor.service";
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { MessageService, ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DialogService } from "primeng/dynamicdialog";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { initializeApp } from 'firebase/app';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';

initializeApp(environment.firebaseConfig);

let swUrl: string;
if (typeof window === 'undefined') {
  swUrl = '/custom-sw.js';
} else if (window.location.hostname === 'localhost') {
  swUrl = '/custom-sw.js'; // dev
} else {
  swUrl = 'https://dev.appgrowthcompany.com/notchmark/web/custom-sw.js'; // prod sub-path
}

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export const appConfig: ApplicationConfig = {
  // providers: [
  //   provideRouter(routes),
  //   provideAnimationsAsync(),
  //   providePrimeNG({
  //     theme: {
  //       preset: Aura,
  //       options: { mode: 'light', darkModeSelector: false || 'none'}
  //     },
  //   }),
  // ],
   providers: [
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
      withEnabledBlockingInitialNavigation()
    ),
    // provideAppInitializer(() => inject(InitialService).setUpGoogleScript()),
    // provideAppInitializer(() => {
    //   const platformId = inject(PLATFORM_ID);
    //   if (isPlatformBrowser(platformId)) {
    //     return inject(RegionService).getRegionsList();
    //   }
    //   return;
    // }),
 
    provideAnimationsAsync(),
    provideServiceWorker(swUrl, {
      enabled: true,
      registrationStrategy: 'registerWhenStable:3000'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptor,
      multi: true,
    },
    

    providePrimeNG({
      theme: {
        preset: Aura,
        // eslint-disable-next-line no-constant-binary-expression
        options: { mode: "light", darkModeSelector: false || "none" },
      },
    }),
    // provideClientHydration(withEventReplay()),
    // provideExperimentalZonelessChangeDetection(),
    provideAnimationsAsync(),
    TranslateService,
    DynamicDialogRef,
    DialogService,
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
  ],
};


